import { createSelector } from 'reselect';

import type { State } from 'reducers';

export const selectWalletTransactionState = (state: State) =>
  state.get('entities').walletTransaction;

export const selectWalletTransactions = createSelector(
  selectWalletTransactionState,
  (walletTransactionState) => walletTransactionState.get('walletTransactions')
);

export const selectWalletTransactionsByUser = createSelector(
  selectWalletTransactions,
  (_walletTransactionState, userId: string) => userId,
  (walletTransactions, userId) =>
    walletTransactions.filter((walletTransaction) => walletTransaction?.user?.id === userId)
);

export const selectCreditingTransactionsByUser = createSelector(
  selectWalletTransactionsByUser,
  (walletTransactions) =>
    walletTransactions.filter(
      (walletTransaction) =>
        !!walletTransaction?.creditAmount && walletTransaction?.creditAmount > 0
    )
);
